module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAIklEQVQ4T2NgGBTgez3Df3SMDhjmJWDiUQNGDRhcBgxtAADO6KPeUoNMqwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/CI.png
// module id = 1109
// module chunks = 0